import type {
  IToastPreset,
  ToastPresetType,
} from '../types';

export const TOAST_PRESETS: { [key in ToastPresetType]: IToastPreset } = {
  access_error: {
    type: 'access_error',
    severity: 'error',
  },
  copied: {
    type: 'copied',
    severity: 'info',
  },
  created: {
    type: 'created',
    severity: 'success',
  },
  edited: {
    type: 'edited',
    severity: 'success',
  },
  error: {
    type: 'error',
    severity: 'error',
  },
  removed: {
    type: 'removed',
    severity: 'success',
  },
  success: {
    type: 'success',
    severity: 'success',
  },
};

export const RETRY_QUERY_TOAST_GROUP = 'retry-query-toast';
